import { changeDateFormat } from "../../utils/util_functions";
import { getOneNews } from "../../utils/api";
import { START_LOADING, END_LOADING } from "./loading_actions";
export const CURR_NEWS_ADD = 'CURR_NEWS_ADD';
export const CURR_NEWS_DEL = 'CURR_NEWS_DEL';



export const getNewsThunk = (id, navigate) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING });
    getOneNews(id)
      .then(data => {
        dispatch({ type: CURR_NEWS_ADD, news: changeDateFormat([data])[0] });
      })
      .catch(error => {
        console.log('error =', error);
        dispatch({ type: CURR_NEWS_DEL });
        navigate('/not-found', { replace: true });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
